import script from "./SettingsOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsOverlay.vue?vue&type=script&setup=true&lang=ts"

import "./SettingsOverlay.vue?vue&type=style&index=0&id=8c15abe0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c15abe0"]])

export default __exports__